/*
  Add to cart without leaving the page.

  Dawn's own add-to-cart forms sit inside <product-form>, which fetches
  /cart/add and hands the response to <cart-drawer>. The custom HME forms (the
  PDP buy box, its add-ons, the mask-match strip) are bare {% form 'product' %}
  tags, so submitting one was a real POST and the shopper landed on /cart,
  losing the page they were reading. <product-form> is not a drop-in for them:
  its constructor and submit handler both reach for Dawn button internals
  (a .loading__spinner, a <span> label) that three differently styled HME
  buttons do not have.

  So intercept the submit instead and reuse the same <cart-drawer> the Dawn
  path uses. One delegated listener covers every custom form on the page,
  including any a section renders after load.

  Degrades to a plain POST: with no drawer on the page (settings.cart_type is
  'page' or 'notification'), before JS boots, or on a network failure, the form
  submits normally and /cart still works.
*/
(function () {
  // Forms Dawn already drives. Handling them here too would add twice.
  var DAWN_OWNED = 'product-form, quick-add-bulk, quick-order-list';
  var IN_FLIGHT = 'data-hme-adding';

  function emit(key, data) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS[key], data);
    }
  }

  // Every button that can submit this form. The PDP's sticky bar button sits
  // outside the form and reaches it with form="hme-pdp-form", so it never turns
  // up in form.querySelectorAll but does arrive as evt.submitter.
  function buttonsFor(form, submitter) {
    var list = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]'));
    if (form.id && window.CSS && CSS.escape) {
      Array.prototype.forEach.call(
        document.querySelectorAll('[type="submit"][form="' + CSS.escape(form.id) + '"]'),
        function (btn) {
          if (list.indexOf(btn) === -1) list.push(btn);
        }
      );
    }
    if (submitter && list.indexOf(submitter) === -1) list.push(submitter);
    return list;
  }

  function setBusy(buttons, busy) {
    buttons.forEach(function (btn) {
      btn.classList.toggle('hme-atc--loading', busy);
      if (busy) btn.setAttribute('aria-disabled', 'true');
      else btn.removeAttribute('aria-disabled');
    });
  }

  // No HME form has an error slot, so borrow the space right below it. Reused
  // on repeat failures rather than stacking a second message.
  function showError(form, message) {
    var slot = form.nextElementSibling;
    if (!slot || !slot.classList.contains('hme-atc-error')) {
      slot = document.createElement('p');
      slot.className = 'hme-atc-error';
      slot.setAttribute('role', 'alert');
      form.insertAdjacentElement('afterend', slot);
    }
    slot.textContent = message;
    slot.hidden = !message;
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!(form instanceof HTMLFormElement)) return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (form.closest(DAWN_OWNED)) return;

    var cart = document.querySelector('cart-drawer');
    if (!cart || typeof cart.renderContents !== 'function') return;
    if (form.hasAttribute(IN_FLIGHT)) {
      evt.preventDefault();
      return;
    }

    evt.preventDefault();
    showError(form, '');

    var buttons = buttonsFor(form, evt.submitter);
    form.setAttribute(IN_FLIGHT, '');
    setBusy(buttons, true);

    var body = new FormData(form);
    body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
    body.append('sections_url', window.location.pathname);
    cart.setActiveElement(evt.submitter || buttons[0] || form);

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = body;

    fetch(window.routes.cart_add_url, config)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) {
          emit('cartError', {
            source: 'hme-cart-drawer-add',
            productVariantId: body.get('id'),
            errors: data.errors || data.description,
            message: data.message,
          });
          showError(form, data.description || data.message || window.cartStrings.error);
          return;
        }

        emit('cartUpdate', {
          source: 'hme-cart-drawer-add',
          productVariantId: body.get('id'),
          cartData: data,
        });
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      })
      .catch(function (e) {
        // The add may or may not have landed, so send them where they can see
        // the truth rather than guessing at a message.
        console.error(e);
        window.location = window.routes.cart_url;
      })
      .finally(function () {
        form.removeAttribute(IN_FLIGHT);
        setBusy(buttons, false);
      });
  });
})();
